<script setup>
import { useQuasar } from 'quasar'
import i18n from '@/plugins/i18n'

const $q = useQuasar()
const t = i18n.global.t

defineProps({
  contacts: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },

})

const emit = defineEmits(['update:current', 'edit', 'delete'])

const onEdit = (id, reset) => {
  emit('edit', id, reset)
}

const onDelete = (id, reset) => {
  $q.dialog({
    title: t('common.confirmDelete'),
    message: t('phonebook.confirmDeleteMessage'),
    cancel: true,
    persistent: true
  }).onOk(() => {
    emit('delete', id)
  }).onCancel(() => {
    reset()
  }).onDismiss(() => {
    reset()
  })
}
</script>

<template>
  <q-virtual-scroll
    v-if="contacts && contacts.length > 0"
    v-slot="{ item: contact }"
    :items="contacts"
    bordered
    separator
    flat
    class="col rounded-borders"
    style="max-height: 55vh;"
  >
    <q-item :key="contact.id">
      <q-item-section avatar>
        <q-avatar
          color="primary"
          text-color="white"
        >
          {{ contact.letter }}
        </q-avatar>
      </q-item-section>

      <q-item-section>
        <q-item-label>{{ contact.name }}</q-item-label>
        <q-item-label
          caption
          lines="1"
        >
          {{ contact.phone_number }}
        </q-item-label>
      </q-item-section>

      <q-item-section side>
        <div class="row q-gutter-xs">
          <q-btn
            flat
            round
            dense
            color="grey"
            icon="mdi-pencil"
            @click.stop="onEdit(contact.id, () => {})"
          >
            <q-tooltip>{{ $t('common.edit') }}</q-tooltip>
          </q-btn>

          <q-btn
            flat
            round
            dense
            color="negative"
            icon="mdi-delete"
            @click.stop="onDelete(contact.id, () => {})"
          >
            <q-tooltip>{{ $t('common.delete') }}</q-tooltip>
          </q-btn>
        </div>
      </q-item-section>
    </q-item>
  </q-virtual-scroll>

  <q-card
    v-else-if="!loading"
    class="text-center q-pa-lg bg-grey-1 dashed-border"
  >
    <q-card-section>
      <div class="text-grey-6">
        {{ $t('phonebook.list.empty') }}
      </div>
    </q-card-section>
  </q-card>

  <q-inner-loading :showing="loading">
    <q-spinner
      color="primary"
      size="3em"
    />
  </q-inner-loading>
</template>
